export const routes = {
    home: '/',
    login: '/login',
    register: '/register',
    profile: '/:username',
    quiz: '/:username/:id',
    category: '/categories/:category'

};